<script setup>
import { ref, computed } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();

const value = defineModel();

const { validation, isValid, isTouched, textError } = useValidation(value)

const isPassword = ref(false);
const errorText = ref(null)

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})
const togglePassword = () => isPassword.value = !isPassword.value;



defineProps({
   
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
    },
    responseError: {
        type: Object, 
        default: () => ({ active: false, text: '' })
    }
})

</script>
<template>
    <div class="password">
        <button class="input__password-btn" @click="togglePassword" type="button">
            <svg width='24' height='24'><use :href="isPassword ? '#eye' : '#eye_closed'"></use></svg>
        </button>
        <label :class="['input']"> 
            <div class="input__holder" :class="[isTouched && (isValid ? 'valid' : 'not-valid')]">
                <input 
                    :type="isPassword ? 'text' : 'password'"
                    :placeholder="placeholder"
                    :required="required"
                    :class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid') ]"
                    @input="storeField.updateFields(stateKey, 'title', value), validation(stateKey)"  
                    @blur="validation(stateKey)"
                    v-model="value"     
                >
                <span class="input__title"><slot></slot></span>
            </div>             
            
            <Transition mode="out-in">
                <span v-if="!!textError" ref="errorText" :style="{ bottom: `${(heightErrorText + 10) * -1}px` }" class="input__error">{{ textError }}</span>
            </Transition>
            
        </label>
    </div>
</template>
<style lang='scss' scoped>
.password {
    position: relative;
}


.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}

</style>